import { render, staticRenderFns } from "./tabLeadTasks.vue?vue&type=template&id=351cce47&"
import script from "./tabLeadTasks.vue?vue&type=script&lang=js&"
export * from "./tabLeadTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports